import React from 'react';
import { Button } from '@guildeducationinc/recess';
import { CATALOG_URL } from '@src/constants';
import ActionCard from '@shared/ActionCard/ActionCard';
import ActionCardButtons from '@shared/ActionCard/ActionCardButtons';
import ActionCardContent from '@shared/ActionCard/ActionCardContent';
import { clickable } from '@src/analytics';

export const ApplicationsActionCard: React.FC = () => {
  const content = {
    estimate: '20 - 30 MIN',
    title: 'Take the first step in your education journey.',
    body: 'Find the program for you and apply!',
  };

  const icon = {
    src: 'https://guild.imgix.net/student-home/programs-and-applications/catalog-circle.svg',
    alt: 'Applications',
  };

  return (
    <ActionCard icon={icon} className='width--full'>
      <ActionCardContent {...content} />
      <ActionCardButtons>
        <Button
          href={CATALOG_URL}
          onClick={() =>
            clickable({
              product: 'home',
              loggedIn: true,
              tag: 'learn_skills',
              text: 'applications_explore_catalog',
              type: 'button',
            })
          }
        >
          Explore catalog
        </Button>
      </ActionCardButtons>
    </ActionCard>
  );
};
